module.exports = __webpack_public_path__ + "static/media/credits.8bb5f0ef.svg";